module.exports = __webpack_public_path__ + "fonts/Caveat-Regular.65f9db2d.ttf";